import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { OverlayTrigger } from "react-bootstrap";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import lockGrey from "../../assets/icons/lockGrey.svg";
import lockBlue from "../../assets/icons/lockBlue.svg";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import LogoSmall from "../../assets/images/logo-small.png";
import ASC from "../../assets/images/ASC22.jpg";
import "../../assets/styles/local/Documents.css";
import "../../assets/styles/local/AddProject.css";

import {
  AddDocumentToProject,
  Fetchdocumentbyprojectid,
  fetchTranslationData,
  deleteDoc,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../redux/constants/type";
import ToastContainer from "react-bootstrap/ToastContainer";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Toast from "react-bootstrap/Toast";
import { FileMimeType } from "../../utils/Documents/contentType";
import roundFileSize from "../../utils/Documents/roundFileSize";
import moment from "moment";
import {
  BsFillEyeFill,
  BsFillEyeSlashFill,
  BsChevronDown,
  BsChevronLeft,
  BsChevronRight,
} from "react-icons/bs";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import DocumentUploaderWithProgress from "../../components/Common/Document_Uploader_With_Progress";

const Documents = ({ setDataBind, dataBind }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const initialRender = useRef(true);
  const [deleteDocument, setDeleteDocument] = useState(false);
  const [deleteRowIndex, setDeleteRowIndex] = useState(null);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const hidden_Input_File = useRef(null);
  const companyId = window.localStorage.getItem("companyid");
  const roleAccess = window.localStorage.getItem("roleid");
  const userId = window.localStorage.getItem("userid");
  const userimag = window.localStorage.getItem("userimageurl");
  const userfirstname = window.localStorage.getItem("firstname");
  const userlastname = window.localStorage.getItem("lastname");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const addDocumentProject = useSelector(
    (state) => state.user.addDocumentProject
  );
  const fetchDocumentProject = useSelector(
    (state) => state.user.fetchDocumentProject
  );
  const dltDoc = useSelector((state) => state.user.deleteDoc);
  const createProject = useSelector((state) => state.user.createProject);

  //////////////  VARIABLES START //////////////

  const [apimessage, setApimessage] = useState("");

  const [fetchDocumentsData, setFetchDocumentsData] = useState([]);
  const [documentDate, setDocumentDate] = useState("");
  const [documentid, setDocumentid] = useState("");
  const [uploadedbyfirstname, setUploadedbyfirstname] = useState("");
  const [uploadedbylastname, setUploadedbylastname] = useState("");
  const [documentname, setDocumentname] = useState("");
  const [documentsize, setDocumentsize] = useState("");
  const [uploadedby, setUploadedby] = useState("");

  const [filelist, setFilelist] = useState(fetchDocumentsData || []);
  // let filelist = fetchDocumentsData || [];
  const [asc, setAsc] = useState("");

  //// FOR PAGINATION START ///
  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  const calculatePagination = (pageNumber) => {
    let records = filelist || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(10 * pageNumber - 9, 1),
      endRecordIndex: Math.min(10 * pageNumber, records.length),
      totalPages: Math.ceil(records.length / 10),
      records: records?.slice((pageNumber - 1) * 10, pageNumber * 10),
    };
    setPaginationObj({ ...tempPaginationObj });
  };

  useEffect(() => {
    calculatePagination(1);
  }, [filelist]);
  //// FOR PAGINATION END ///
  useEffect(() => {
    fetchScreenTranslations("Update-Project").then((res) => {
      setFetchTranslationList(res);
    });
  }, []);
  /////////////ASC FOR DOCUMENTS UPLOAD START/////////////
  const handleDeleteDocumentFun = () => {
    let filterItem = dataBind.filter((item) => item.link !== item.link);

    let data = [...dataBind];
    data.splice(deleteRowIndex, 1);

    let data2 = [...filelist];
    data2.splice(deleteRowIndex, 1);
    setFilelist(data2);
    setDataBind([...filterItem]);
    dispatch(deleteDoc(deleteRowData.documentid));
    // setDataBind(fetchDocumentsData);

    setDeleteDocument(false);
    setDeleteRowIndex(null);
    setDeleteRowData(null);
  };

  const handleIMGClick = () => {
    hidden_Input_File.current.click();
  };

  const onFileUploaded = (data) => {
    setFilelist([
      ...filelist,
      {
        documentname: data[0].name,
        documentextension: data[0].type,
        documentcontent: "string",
        link: data[0].link,
        documentsize: data[0].size,
      },
    ]);

    setDataBind([
      ...dataBind,
      {
        documentname: data.name,
        documentextension: data.type,
        documentcontent: "string",
        link: data.link,
        documentsize: data.size,
      },
    ]);
  };

  /////////////ASC FOR DOCUMENTS UPLOAD END///////////

  //////////// ASC DOCUMENTS DOWNLOAD START ////////////

  const pdfDownload = (item) => {
    axios({
      method: "get",
      // url: `${API_URL}/api/Files/DownloadFiles?documentid=${documentid}`,
      url: `${API_URL}/api/Files/DownloadFiles?documentid=${item.forpdfDocumentID}`,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      // data: {
      //   documentid: documentid
      // },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      // link.setAttribute("download", `FinalDocument.docx`);
      link.setAttribute(
        "download",
        // `Document.${FileMimeType[ response.headers[ "content-type" ] ]}`
        `${item.forpdfDocumentName}.${
          FileMimeType[response.headers["content-type"]]
        }`
      );

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
      // return docFileDownload;
      // }, 1000)
    });
  };

  //////////// ASC DOCUMENTS DOWNLOAD END ////////////

  // dispatch Fetchdocumentbyprojectid after doc dlt start

  // useEffect(() => {
  //   if (dltDoc?.status === true) {
  //     dispatch(Fetchdocumentbyprojectid(projectId));
  //   } else {
  //   }
  // }, [dltDoc]);

  // dispatch Fetchdocumentbyprojectid after doc dlt end

  /////////// ASC FETCH DOCUMENTS API START /////////

  const projectId = window.localStorage.getItem("projectid");

  useEffect(() => {
    dispatch(Fetchdocumentbyprojectid(projectId));
  }, []);

  useEffect(() => {
    if (fetchDocumentProject?.status === true) {
      // setApimessage(fetchDocumentProject?.data?.message)
      setFetchDocumentsData(fetchDocumentProject?.data);
      setFilelist(fetchDocumentProject?.data);
      setUploadedbyfirstname(
        fetchDocumentProject?.data[0]?.uploadedbyfirstname
      );
      setUploadedbylastname(fetchDocumentProject?.data[0]?.uploadedbylastname);
      setDocumentname(fetchDocumentProject?.data[0]?.documentname);
      setDocumentDate(fetchDocumentProject?.data[0]?.date);
      setDocumentsize(fetchDocumentProject?.data[0]?.documentsize);
      setUploadedby(fetchDocumentProject?.data[0]?.uploadedby);
    } else {
      setApimessage(fetchDocumentProject?.message);
    }
  }, [fetchDocumentProject]);

  //////// ASC FETCH DOCUMENTS API END //////////////

  return (
    <>
      <div
        className={
          roleAccess === "08da3f0d-0371-4dd3-8c86-e51222d5619"
            ? "pointerEvent container-fluid pt-4 inner-highlighter"
            : "container-fluid inner-highlighter pt-4"
        }
      >
        <div className="d-flex gap-2 ps-2 pointer quotes-div-1 fr">
          <DocumentUploaderWithProgress
            maxSizeInMb={100}
            onUploaded={onFileUploaded}
            multiple={true}
          >
            <section className="fr gap-2">
              <img src={CardAddButton} className="addDocImg" alt="" />
              <p className="pt-1 addDocText">
                {t("Add Document")}
              </p>
            </section>
          </DocumentUploaderWithProgress>

          {/* FOR PAGINATION START */}

          <div className="stock-custom-pagination">
            <div>
              {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex}  of  ${paginationObj.totalRecords}`}
            </div>
            <div className="pagination-buttons">
              <div
                className={`update-stock-pagination-button ${
                  paginationObj.currentPage === 1 ? "disabled" : ""
                }`}
                onClick={() =>
                  calculatePagination(paginationObj.currentPage - 1)
                }
              >
                <BsChevronLeft />
              </div>
              <div className="pagination-current-page">
                {paginationObj.currentPage}
              </div>
              <div
                className={`update-stock-pagination-button ${
                  paginationObj.totalPages === 0 ||
                  paginationObj.totalPages === paginationObj.currentPage
                    ? "disabled"
                    : ""
                }`}
                onClick={() =>
                  calculatePagination(paginationObj.currentPage + 1)
                }
              >
                <BsChevronRight />
              </div>
            </div>
          </div>

          {/* FOR PAGINATION END */}
        </div>

        <table className="table table-borderless">
          <thead>
            <tr className="textHeadings">
              <th scope="col actionGap">
                {/* Actions */}
                {t("Actions")}
              </th>
              <th scope="col documentGap">
                {/* Document Name */}
                {t("Document Name")}
              </th>
              <th scope="col">
                {/* Size */}
                {t("Size")}
              </th>
              <th scope="col">
                {/* Date */}
                {t("Date")}
              </th>
              <th scope="col">
                {/* Uploaded by */}
                {t("Updated by")}
              </th>
            </tr>
          </thead>

          {/* {filelist.map((item, index) => { */}
          {paginationObj.records.map((item, index) => {
            return (
              <>
                <tbody key={index}>
                  <tr className="actionGap">
                    <td className="d-flex gap-3">
                      {/* {userId === item.userid && ( */}
                      <img
                        // className="dltIcon pointer"
                        // className={userId === item.userid ? "dltIcon pointer" : "invisible"}
                        className={
                          userId === item.userid ||
                          roleAccess === process.env.REACT_APP_IS_MANAGER
                            ? "dltIcon pointer"
                            : userId === item.userid ||
                                roleAccess === process.env.REACT_APP_IS_OWNER
                              ? "dltIcon pointer"
                              : "invisible"
                        }
                        src={DeleteIcon}
                        alt=""
                        onClick={() => {
                          setDeleteRowData(item);
                          setDeleteRowIndex(index);
                          setDeleteDocument(true);
                        }}
                      />
                      {/* )} */}
                      <img className="dltIcon pointer" src={lockGrey} alt="" />
                      {/* <img className="pointer" src={lockBlue} alt="" /> */}
                    </td>

                    <td
                      className="documntName pointer"
                      // onClick={pdfDownload}
                      onClick={() => {
                        setDocumentid(item.documentid);
                        setDocumentname(item.documentname);
                        pdfDownload({
                          forpdfDocumentID: item.documentid,
                          forpdfDocumentName: item.documentname,
                        });
                      }}
                    >
                      {/* {item.documentname} */}

                      <OverlayTrigger
                        key={index}
                        placement="top"
                        id="asctooltip"
                        // show={show}
                        // target={target}
                        delay={{ show: 400, hide: 500 }}
                        overlay={
                          <div
                            id={`tooltip-${item.documentname}`}
                            style={{ paddingLeft: "15rem" }}
                          >
                            <p className="ascOverlay px-1">
                              {item.documentname.length > 30 &&
                                item.documentname}
                            </p>
                          </div>
                        }
                      >
                        <p className="clntname pt-2">
                          {item.documentname.length > 30
                            ? item.documentname.slice(0, 30) + "..."
                            : item.documentname}
                        </p>
                      </OverlayTrigger>
                    </td>

                    <td className="documntName">
                      {roundFileSize(item.documentsize)}
                    </td>

                    <td className="documntName">
                      {moment(item.documentDate).format("DD.MM.YYYY")}
                    </td>

                    <td className="ps-3">
                      {/* <img className="" src={item.uploadedby} alt="" /> */}
                      {item.uploadedbyfirstname || item.uploadedbylastname
                        ? `${item.uploadedbyfirstname} ${item.uploadedbylastname}`
                        : `${userfirstname} ${userlastname}`}

                      {/* {`${item.uploadedbyfirstname} ${item.uploadedbylastname}`} */}

                      {/* <div
                                                className="col-1 ft pe-0"
                                                style={{
                                                    justifyContent: "flex-end",
                                                    display: "flex",
                                                }}
                                            >
                                                {userimag ? (
                                                    <img
                                                        style={{
                                                            width: "20px",
                                                            height: "20px",
                                                            borderRadius: "50%",
                                                        }}
                                                        alt="senderimg"
                                                        src={userimag}
                                                    />
                                                ) : (
                                                    <div className="abbrCss me-1">

                                                        {userfirstname?.toUpperCase()
                                                            ? userfirstname
                                                                .slice(0, 1)
                                                                .toUpperCase() +
                                                            userlastname.slice(0, 1).toUpperCase()
                                                            : userfirstname
                                                                ?.slice(0, 1)
                                                                .toUpperCase() +
                                                            userfirstname
                                                                ?.slice(1, 2)
                                                                .toUpperCase()}
                                                    </div>
                                                )}
                                            </div> */}
                    </td>
                  </tr>
                </tbody>
              </>
            );
          })}
          {/* {fetchDocumentsData.length === 0 && <span>No data to display!</span>} */}
        </table>
      </div>
      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          // title1={"This data will be removed from the system"}
          title1={t("This data will be removed from the system")}
          // title2={"and cannot be undone."}
          title2={t("and cannot be done.")}
          title3={t("Do you want to proceed?")}
          no={t("No")}
          yes={t("Yes")}
        />
      )}
    </>
  );
};

export default Documents;
